import { Component, CUSTOM_ELEMENTS_SCHEMA, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ImageViewerData {
  imageUrl: string;
  title?: string;      // defaults to "Image URL"
  imageName?: string;  // defaults to the file name taken from the URL
}

@Component({
  selector: 'app-image-view-preview-dialog-v2',
  standalone: true,
  imports: [CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './image-view-preview-dialog-v2.component.html',
})
export class ImageViewDialogPreviewV2Component {
  loadFailed = false;

  constructor(
    private dialogRef: MatDialogRef<ImageViewDialogPreviewV2Component>,
    @Inject(MAT_DIALOG_DATA) public data: ImageViewerData,
  ) {}

  get title(): string {
    return this.data.title ?? 'Image URL';
  }

  get fileName(): string {
    if (this.data.imageName) { return this.data.imageName; }

    const url = this.data.imageUrl ?? '';
    try {
      return decodeURIComponent(new URL(url).pathname.split('/').pop() ?? '');
    } catch {
      return url.split('/').pop()?.split('?')[0] ?? '';
    }
  }

  close(): void {
    this.dialogRef.close();
  }
}
